/**
 * <s-sort-sheet> — Cute sort picker.
 * The hidden native <select name="sort_by"> stays the form's source of truth (so
 * <s-live-form> and no-JS submits keep working). Each [data-sort-value] button in the
 * sheet sets the select, fires a bubbling `change`, updates the trigger label and
 * pressed state, then closes the sheet dialog.
 */
class SSortSheet extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const option = event.target instanceof Element ? event.target.closest('[data-sort-value]') : null;
      if (!option || !this.contains(option)) return;
      const select = this.querySelector('select[name="sort_by"]');
      const dialog = this.querySelector('dialog');
      const value = option.getAttribute('data-sort-value');
      this.querySelectorAll('[data-sort-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === option));
      });
      const current = this.querySelector('[data-sort-current]');
      if (current) current.textContent = option.getAttribute('data-sort-label') || '';
      if (dialog && dialog.open) dialog.close();
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-sort-sheet')) customElements.define('s-sort-sheet', SSortSheet);
